import React, { Suspense } from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import {Link} from 'react-router-dom'
import { badDataAnalytics, getAccount, getAllMeter, getAllModem, getAreaById, getCircleById, getDivisionById, getGaById, getRolesById, getSubdevisionById, getTags, onGetConsumerIncolumeName, onGetConsumerIncolumeNameWithFilter, onGetLoraConsumerIncolumeName, onGetLoraConsumerIncolumeNameWithFilter } from '../../Commoncomponet/Utils'
import { DatePicker, Modal, Space, Spin } from 'antd'
import { Modal as BootstrapModal } from 'react-bootstrap';
import { toast } from 'react-toastify'
import chroma from 'chroma-js';
import MultiInput from '../../Commoncomponet/MultiInput/MultiInput'
import Select from 'react-select';
import moment from 'moment'
import makeAnimated from 'react-select/animated';
import { BootstrapTooltip } from '../../Commoncomponet/common'
import classNames from 'classnames'

const FilterDisplay = ({ filter, onClearFilter,onRedirectMap }) => {
	console.log('filter', filter)
	const [showAll, setShowAll] = useState(false);
	const [popoverVisible, setPopoverVisible] = useState(false);
	const maxValues = 10;

	if (Object.entries(filter).length === 0) { return null }
	const filterEntries = Object.entries(filter);

	const totalValues = filterEntries.reduce((count, [, value]) => {
		if (Array.isArray(value)) {
			return count + value.length;
		} else {
			return count + 1;
		}
	}, 0);

	// const viewMoreButton = totalValues > maxValues ? (
	// 	<button
	// 		onClick={() => setShowAll(!showAll)}
	// 		className='tw-bg-blue-100 tw-whitespace-nowrap tw-rounded-md tw-text-xs tw-px-2 tw-py-1 border !tw-border-blue-500 hover:tw-bg-blue-200 tw-transition-all tw-mr-2'
	// 	>
	// 		{showAll ? 'View Less' : 'View More'}
	// 	</button>
	// ) : null;

	let valuesDisplayed = 0;
	let keysDisplayed = 0;

	const remainingValues = totalValues - maxValues;
	const viewMoreButton = totalValues > maxValues && !showAll ? (
		<button
			onClick={() => setShowAll(true)}
			className='tw-bg-orange-100 tw-whitespace-nowrap tw-rounded-md tw-text-xs tw-px-2 tw-py-1 border !tw-border-orange-500 hover:tw-bg-orange-200 tw-transition-all tw-mr-2'>
			+{remainingValues}
		</button>
	) : null;


	const filterValues = filterEntries.map(([key, value]) => {
		if (!showAll && valuesDisplayed >= maxValues) {
			console.log('returning null')
			return null;
		}

		let valueOutput;
		if (key === 'RSSI' || key === 'BAT_PER') {
			if (value?.LessEqual === 'True') {
				valueOutput = (
					<> LessAndEqualTo{' '} <span className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1">{value?.Value}</span> </>
				);
			} else if (value?.GreaterEqual === 'True') {
				valueOutput = (
					<> GreaterAndEqualTo{' '} <span className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1">{value?.Value}</span> </>
				);
			} else {
				valueOutput = (
					<> between{' '} <span className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1 border tw-whitespace-nowrap !tw-border-indigo-500">{value?.From}</span>{' '} and{' '} <span className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1 border !tw-border-indigo-500 tw-whitespace-nowrap">{value?.To}</span> </>
				);
			}
			valuesDisplayed++;
		} else if (key === 'Last_Seen') {
			valueOutput = (
				<> {value?.LessEqual === 'True' ? 'less than' : 'more than'}{' '} <span className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1 border !tw-border-indigo-500 tw-whitespace-nowrap">{value?.Value} {value?.Last_Seen}</span>{' '} </>
			);
			valuesDisplayed++;
		} else if (key === 'Installation_Date' || key === 'Dataretrival_Date') {
			if (value?.LessEqual === 'True') {
				valueOutput = (
					<> LessAndEqualTo{' '} <span className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1 border !tw-border-indigo-500 tw-whitespace-nowrap">{value?.Start_Date}</span> </>
				);
			} else if (value?.GreaterEqual === 'True') {
				valueOutput = (
					<> GreaterAndEqualTo{' '} <span className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1 border !tw-border-indigo-500 tw-whitespace-nowrap">{value?.Start_Date}</span> </>
				);
			} else {
				valueOutput = (
					<> between{' '} <span className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1 border !tw-border-indigo-500 tw-whitespace-nowrap">{value?.Start_Date}</span>{' '} and{' '} <span className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1 border !tw-border-indigo-500 tw-whitespace-nowrap">{value?.End_Date}</span> </>
				);
			}
			valuesDisplayed++;
		} else if (Array.isArray(value)) {
			const displayedValues = showAll ? value : value.slice(0, maxValues - valuesDisplayed);
			valueOutput = displayedValues.map((v, i) => (
				<span key={i} className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1 border !tw-border-indigo-500 tw-whitespace-nowrap"> {v} </span>
			));
			valuesDisplayed += displayedValues.length;
		} else if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
			valueOutput = (
				<span className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1 border !tw-border-indigo-500 tw-whitespace-nowrap"> {JSON.stringify(value)} </span>
			);
			valuesDisplayed++;
		} else {
			valueOutput = (
				<span className="border tw-rounded tw-px-2 tw-py-1 tw-mx-1 border !tw-border-indigo-500 tw-whitespace-nowrap"> {value} </span>
			);
			valuesDisplayed++;
		}

		return (
			<>
				<strong className="mr-1">{key}:</strong>
				{valueOutput}
			</>
		);
	});
	return (
		<div className={classNames("tw-mb-4 tw-px-1 tw-flex tw-items-center tw-gap-2")}>
			<h3 className="tw-my-0 tw-text-sm tw-font-bold tw-bg-[#f1f1f1] tw-py-1 tw-px-2 tw-rounded-lg">Filters:</h3>

			{showAll && (
				<div className="tw-flex tw-flex-wrap tw-gap-1 tw-text-xs tw-items-center">
					<div className="tw-absolute tw-bg-white tw-p-4 tw-rounded-lg tw-shadow-lg tw-border tw-border-gray-300 tw-z-50 tw-max-w-[90%]">
						<div className="tw-flex tw-flex-wrap tw-gap-1 tw-items-center">

							{filterValues}
							<button onClick={() => setShowAll(false)} className='tw-bg-orange-100 tw-whitespace-nowrap tw-rounded-md tw-px-2 tw-py-1 border !tw-border-orange-500 hover:tw-bg-orange-200 tw-transition-all'> View Less </button>
						</div>
					</div>
				</div>
			)
			}
			<div className="tw-flex tw-flex-wrap tw-gap-1 tw-text-xs tw-items-center tw-max-w-[90%]">
				<>
					{filterValues.slice(0, maxValues)}
					{viewMoreButton}
				</>

				<div className=''>
					<button onClick={onClearFilter} className='tw-bg-red-100 tw-whitespace-nowrap tw-rounded-md tw-text-xs tw-px-2 tw-py-1 border !tw-border-red-500 hover:tw-bg-red-200 tw-transition-all'> Clear Filter </button>
				</div>
				{/* <div className=''>
					<button className='tw-bg-blue-100 tw-whitespace-nowrap tw-rounded-md tw-text-xs tw-px-2 tw-py-1 border !tw-border-blue-500 hover:tw-bg-blue-200 tw-transition-all' onClick={onRedirectMap}> Redirect Map </button>
				</div> */}
			</div>
		</div>
	);
}
export default function MissingDataAnalytice() {
    const buttonArray = ["GSM","Lorawan"];

    const [BadData, setBadData] = useState({})
    const [TableData, setTableData] = useState([])
    const [ModalLoad, setModalLoad] = useState(false)
    const [isModalVisible, setisModalVisible] = useState(false)
    const [ModelId, setModelId] = useState('')
    const [Loader, setLoader] = useState(false)
    const [btnText, setButtontext] = useState("GSM");
    const [ModemData, setModemData] = useState([]);
	const [MeterData, setMeterData] = useState([]);
	const [filterObj, setFilterObj] = useState({Status:'1'})
    const [SubdevisionData, setSubdevisionData] = useState([]);
	const [DivisionData, setDivisionData] = useState([]);
	const [CircleData, setCircleData] = useState([]);
	const [GaData, setGaData] = useState([]);
	const [AccounData, setAccountData] = useState([]);
	const [AreaData, setAreaData] = useState([]);
	const [showfilterObj, setShowFilterObj] = useState({Status: 'Active' })
    const [ismodelFilter,setismodelFilter]=useState(false)
	const [searchTerms, setSearchTerms] = useState([]);
    const [permision,setpermision]=useState({})
    const userInfo = JSON.parse(window.localStorage.getItem("user_info"));
	const btnColor = ['#4f5ece', '#f59e0b', '#fc544b', '#3abaf4', '#54ca68', '#191d21', '#7c5295', '#4f5ece']
    const [Profile, setProfile] = useState({
		accountuser: false,
		gauser: false,
		circleuser: false,
		areauser: false,
		divisionuser: false,
		subDivisionuser: false,
	})

	const [consumer, setConsumer] = useState({
		checktext1: false,
		checktext2: false,
		checktext3: false,
		checktext4: false,
		checktext5: false,
		checktext6: false,
		checktext7: false,
		checktextCS: false,
		checktextMP: false,
		checktextMOP: false,
		checktextTA: false,
		checktextInTS: false,
		checktextLSs: false,
		Consumer_Type: false,
		checktextDRTS:false
	})
	const [dates, setDates] = useState({ start: '', end: '' })
	const [modem, setModem] = useState({
		checktextRSSI: false,
		checktextLS: false,
		checktextBP: false,
	})


	const [modemStart, setModemState] = useState({
		Between: false,
		lessThan: false,
		greaterThan: false
	})

	const [installState, setinstallState] = useState({
		Between: false,
		lessThan: false,
		greaterThan: false
	})
	const [DRState, setDRState] = useState({
		Between: false,
		lessThan: false,
		greaterThan: false
	})
	const [betteryPr, setbetteryPr] = useState({
		Between: false,
		lessThan: false,
		greaterThan: false
	})

	const [last, setLastSeen] = useState({
		LessEqual: false,
		GreaterEqual: false
	})
	const [tagsList, settagsList] = useState([])
	const [FilterLoader, setFilterLoader] = useState(false)

    const objectComponet = {"Group Details":[{ lable: 'Account', key: 'CAT0_ID' }, { lable: 'CATEGORY1', key: 'CAT1_ID' }, { lable: 'CATEGORY2', key: 'CAT2_ID' }, { lable: 'CATEGORY3', key: 'CAT3_ID' }, { lable: 'CATEGORY4', key: 'CAT4_ID' }, { lable: 'CATEGORY5', key: 'CAT5_ID' }],"Distributor Customer Details":[{ lable: 'Customer ID', key: 'CUSTOMER_ID' }, { lable: 'Installation Number', key: 'INSTALLATION_NUMBER' }, { lable: 'Business Partner Number', key: 'BUSINESS_PARTNER_NUMBER' }, { lable: 'Consumer Type', key: 'CONSUMER_TYPE' }],"Modem Details":[{ lable: 'Modem Profile', key: 'MODEM_TYPE' }, { lable: 'IMEI', key: 'IMEI' }, { lable: 'Modem Serial No', key: 'DEVICE_SERIAL_NO' }, { lable: 'Panel Serial No', key: 'PANEL_SERIAL_NO' }],"EVC/MC Details":[{ lable: 'EVC/MC Profile', key: 'EVC_MC_METER_TYPE' }],"Other Details":[{ lable: 'Data Retrival Date', key: 'DATA_RETRIVE_DATE' }],"Address":[{ lable: 'Consumer Name', key: 'address_compony_name' }, { lable: 'Flat No, House No or Building No', key: 'address_building_no' }, { lable: 'Area, Colony, Street, Village', key: 'address_street_area' }, { lable: 'Landmark', key: 'address_landmark_colony' }, { lable: 'Pin Code', key: 'address_pin_code' }, { lable: 'Country', key: 'address_country_id' }, { lable: 'State', key: 'address_state_id' }, { lable: 'City', key: 'address_city_id' }, { lable: 'Latitude', key: 'address_lattitude' }, { lable: 'Longitude', key: 'address_longitude' }],"Installation Details":[{ lable: 'First Name', key: 'Installation_Person_First_Name' }, { lable: 'Last Name', key: 'Installation_Person_Last_Name' }, { lable: 'Email', key: 'Installation_Person_Email' }, { lable: 'Mobile Number', key: 'Installation_Person_Mobile_Number' }, { lable: 'Work Number', key: 'Installation_Person_Work_Number' }, { lable: 'Position', key: 'Installation_Person_Position' }, { lable: 'Date And Time', key: 'Installation_Date_And_Time' }, { lable: 'Installtion Attachments', key: 'INSTALLATION_ATTECHMENTS' }],"Contact Person":[{ lable: 'Salutation', key: 'salutation' }, { lable: 'First Name', key: 'First_Name' }, { lable: 'Last Name', key: 'Last_Name' }, { lable: 'Email', key: 'Email' }, { lable: 'Mobile Number', key: 'Mobile' }, { lable: 'Work Number', key: 'Work_no' }, { lable: 'Designation', key: 'Designation' }, { lable: 'User type', key: 'UserType' }]}
    
     const objectLoraComponet = {"Group Details":[{ lable: 'Account', key: 'CAT0_ID' }, { lable: 'CATEGORY1', key: 'CAT1_ID' }, { lable: 'CATEGORY2', key: 'CAT2_ID' }, { lable: 'CATEGORY3', key: 'CAT3_ID' }, { lable: 'CATEGORY4', key: 'CAT4_ID' }, { lable: 'CATEGORY5', key: 'CAT5_ID' }],"Distributor Customer Details":[{ lable: 'Customer ID', key: 'CUSTOMER_ID' }, { lable: 'Installation Number', key: 'INSTALLATION_NUMBER' }, { lable: 'Business Partner Number', key: 'BUSINESS_PARTNER_NUMBER' }, { lable: 'Consumer Type', key: 'CONSUMER_TYPE' }],"Modem Details":[{ lable: 'Modem Profile', key: 'MODEM_TYPE' }, { lable: 'EUI', key: 'EUI' }, { lable: 'Modem Serial No', key: 'DEVICE_SERIAL_NO' }, { lable: 'Panel Serial No', key: 'PANEL_SERIAL_NO' }],"EVC/MC Details":[{ lable: 'EVC/MC Profile', key: 'METER_TYPE' },{lable:'EVC/MC Serial No',key:'MECHANICAL_UNIQUE_ID'}],"Other Details":[{ lable: 'Data Retrival Date', key: 'DATA_RETRIVE_DATE' }],"Address":[{ lable: 'Consumer Name', key: 'address_compony_name' }, { lable: 'Flat No, House No or Building No', key: 'address_building_no' }, { lable: 'Area, Colony, Street, Village', key: 'address_street_area' }, { lable: 'Landmark', key: 'address_landmark_colony' }, { lable: 'Pin Code', key: 'address_pin_code' }, { lable: 'Country', key: 'address_country_id' }, { lable: 'State', key: 'address_state_id' }, { lable: 'City', key: 'address_city_id' }, { lable: 'Latitude', key: 'address_lattitude' }, { lable: 'Longitude', key: 'address_longitude' }],"Installation Details":[{ lable: 'First Name', key: 'Installation_Person_First_Name' }, { lable: 'Last Name', key: 'Installation_Person_Last_Name' }, { lable: 'Email', key: 'Installation_Person_Email' }, { lable: 'Mobile Number', key: 'Installation_Person_Mobile_Number' }, { lable: 'Work Number', key: 'Installation_Person_Work_Number' }, { lable: 'Position', key: 'Installation_Person_Position' }, { lable: 'Date And Time', key: 'Installation_Date_And_Time' }, { lable: 'Installtion Attachments', key: 'INSTALLATION_ATTECHMENTS' }],"Contact Person":[{ lable: 'Salutation', key: 'salutation' }, { lable: 'First Name', key: 'First_Name' }, { lable: 'Last Name', key: 'Last_Name' }, { lable: 'Email', key: 'Email' }, { lable: 'Mobile Number', key: 'Mobile' }, { lable: 'Work Number', key: 'Work_no' }, { lable: 'Designation', key: 'Designation' }, { lable: 'User type', key: 'UserType' }]}

    const getBadDataList = async (isLoader) => {
        if(!isLoader){
        setLoader(true)
        }
        const data = await badDataAnalytics({tableName:btnText=="GSM"?"gsm_consumer_device_index":"lora_consumer_device_index",filter_obj:{...filterObj, CATEGORY1_view: permision?.ROLES_PERMISSIONS_CATEGORY1?.CATEGORY1_view, CATEGORY0_view: permision?.ROLES_PERMISSIONS_CATEGORY0?.CATEGORY0_view, CATEGORY2_view: permision?.ROLES_PERMISSIONS_CATEGORY2?.CATEGORY2_view, CATEGORY3_view: permision?.ROLES_PERMISSIONS_CATEGORY3?.CATEGORY3_view, CATEGORY4_view: permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY4_view, CATEGORY5_view: permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY5_view, Roles: userInfo?.ROLE }})
        if (data.success == true) {
            setBadData(data?.data?.data[0] || {})
            setLoader(false)
            setismodelFilter(false)
		setFilterLoader(false)

        } else {
            toast.error('Server Issue')
            setLoader(false)
		setFilterLoader(false)

        }
    }
   
    const onHandaleRoles = async () => {

		const data = await getRolesById(userInfo?.ROLE)
		if (data.success === true) {
			const obj = data.data.data[0]
			const Roles = { ...obj, ROLES_PERMISSIONS_CATEGORY0: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY0), ROLES_PERMISSIONS_CATEGORY5: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY5), ROLES_PERMISSIONS_CATEGORY2: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY2), ROLES_PERMISSIONS_CATEGORY3: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY3), ROLES_PERMISSIONS_CATEGORY1: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY1), ROLES_PERMISSIONS_CATEGORY4: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY4),ROLES_OTHER_PERMISSIONS:JSON.parse(obj.ROLES_OTHER_PERMISSIONS) }
			setpermision(Roles)

		} else {
			console.log('something want wrong')
			setLoader(false)
		}
	}

	const ongetGaById = async (id) => {
		const data1 = await getGaById(id);
		if (data1.success === true) {
			const options = []
			const optionArray = data1?.data?.data.filter((data) => (permision?.ROLES_PERMISSIONS_CATEGORY1?.CATEGORY1_view?.filter((items) => (items === data.CATEGORY1_UNIQUE_ID)).length > 0||filterObj?.CATEGORY0?.includes(data?.CATEGORY0) || userInfo?.ROLE === 'ROLE1650614500708'));
			optionArray.map((item) => (options.push({ value: item?.CATEGORY1_UNIQUE_ID, label: item?.CATEGORY1_NAME })))
			setGaData(options)
		}
	};

	const ongetCircle = async (id) => {
		const data1 = await getCircleById(id);
		if (data1.success === true) {
			const options = []
			const optionArray = data1?.data?.data.filter((data) => (permision?.ROLES_PERMISSIONS_CATEGORY2?.CATEGORY2_view?.filter((items) => (items === data.CATEGORY2_UNIQUE_ID)).length > 0||(filterObj?.CATEGORY0?.includes(data?.CATEGORY0)&&filterObj?.CATEGORY1?.includes(data?.CATEGORY1)) || userInfo?.ROLE === 'ROLE1650614500708'));
			optionArray.map((item) => (options.push({ value: item?.CATEGORY2_UNIQUE_ID, label: item?.CATEGORY2_NAME })))
			setCircleData(options);
		}
	};
	const ongetSubdevisionById = async (id) => {
		const data1 = await getSubdevisionById(id);
		if (data1.success === true) {
			const options = []
			const optionArray = data1?.data?.data.filter((data) => (permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY4_view?.filter((items) => (items === data.CATEGORY4_UNIQUE_ID)).length > 0||(filterObj?.CATEGORY0?.includes(data?.CATEGORY0)&&filterObj?.CATEGORY1?.includes(data?.CATEGORY1)&&filterObj?.CATEGORY2?.includes(data?.CATEGORY2)&&filterObj?.CATEGORY3?.includes(data?.CATEGORY3)) || userInfo?.ROLE === 'ROLE1650614500708'));
			optionArray.map((item) => (options.push({ value: item?.CATEGORY4_UNIQUE_ID, label: item?.CATEGORY4_NAME })))
			setSubdevisionData(options);
		}
	};
	const ongetDivisionById = async (id) => {
		const data3 = await getDivisionById(id);
		if (data3.success === true) {
			const options = []
			const optionArray = data3?.data?.data.filter((data) => (permision?.ROLES_PERMISSIONS_CATEGORY3?.CATEGORY3_view?.filter((items) => (items === data.CATEGORY3_UNIQUE_ID)).length > 0||(filterObj?.CATEGORY0?.includes(data?.CATEGORY0)&&filterObj?.CATEGORY1?.includes(data?.CATEGORY1)&&filterObj?.CATEGORY2?.includes(data?.CATEGORY2)) || userInfo?.ROLE === 'ROLE1650614500708'));
			optionArray.map((item) => (options.push({ value: item?.CATEGORY3_UNIQUE_ID, label: item?.CATEGORY3_NAME })))
			setDivisionData(options);
		}
	};
	const ongetArea = async (id) => {
		const data3 = await getAreaById(id);
		if (data3.success === true) {
			const options = []
			const optionArray = data3?.data?.data.filter((data) => (permision?.ROLES_PERMISSIONS_CATEGORY5?.CATEGORY5_view?.filter((items) => (items === data.UNIQUE_ID)).length > 0||(filterObj?.CATEGORY0?.includes(data?.CATEGORY0)&&filterObj?.CATEGORY1?.includes(data?.CATEGORY1)&&filterObj?.CATEGORY2?.includes(data?.CATEGORY2)&&filterObj?.CATEGORY3?.includes(data?.CATEGORY3)&&filterObj?.CATEGORY4?.includes(data?.CATEGORY4)) || userInfo?.ROLE === 'ROLE1650614500708'));
			optionArray.map((item) => (options.push({ value: item?.UNIQUE_ID, label: item?.CATEGORY5_NAME })))
			setAreaData(options);
		}
	};

	useEffect(() => {
		if (filterObj?.CATEGORY0?.length > 0) {
			ongetGaById(filterObj?.CATEGORY0);
			setCircleData([]);
			setSubdevisionData([]);
			setDivisionData([]);
			setAreaData([])
		} else {
			setGaData([]);
			setCircleData([]);
			setSubdevisionData([]);
			setDivisionData([]);
			setAreaData([]);
		}
	}, [filterObj.CATEGORY0]);

	useEffect(() => {
		if (filterObj?.CATEGORY1?.length > 0) {
			ongetCircle(filterObj?.CATEGORY1);
			setSubdevisionData([]);
			setDivisionData([]);
			setAreaData([]);

		} else {
			setCircleData([]);
			setDivisionData([]);
			setSubdevisionData([]);
			setAreaData([]);


		}
	}, [filterObj.CATEGORY1]);

	useEffect(() => {
		if (filterObj?.CATEGORY2?.length > 0) {
			ongetDivisionById(filterObj?.CATEGORY2);
			setAreaData([]);
			setSubdevisionData([]);

		} else {
			setAreaData([]);
			setDivisionData([]);
			setSubdevisionData([]);
		}
	}, [filterObj.CATEGORY2]);

	useEffect(() => {
		if (filterObj?.CATEGORY3?.length > 0) {
			ongetSubdevisionById(filterObj?.CATEGORY3);
			setAreaData([]);
		} else {
			setSubdevisionData([]);
			setAreaData([]);
		}
	}, [filterObj.CATEGORY3]);

	useEffect(() => {
		if (filterObj?.CATEGORY4?.length > 0) {
			ongetArea(filterObj?.CATEGORY4);
		} else {
			setAreaData([]);

		}
	}, [filterObj.CATEGORY4]);


	const onHandaleAccount = async () => {
		const data = await getAccount();
		if (data.success === true) {
			const options = []
			const optionArray = data?.data?.data.filter((data) => (permision?.ROLES_PERMISSIONS_CATEGORY0?.CATEGORY0_view?.filter((items) => (items === data.UNIQUE_ID)).length > 0 || userInfo?.ROLE === 'ROLE1650614500708'))
			console.log(optionArray);
			optionArray.map((item) => (options.push({ value: item?.UNIQUE_ID, label: item?.CATEGORY0 })))
			setAccountData(options);
		} else {
			console.log("somthing want wrong");
		}
	};

	const ongetAllModem = async () => {
		const data6 = await getAllModem(true);
		if (data6.success === true) {
			const options = []
			data6?.data?.data?.map((item) => (options.push({ value: item?.MODEM_UNIQUE_ID, label: item?.MODEM_PROFILE_NAME })))
			setModemData(options);
		} else {
			console.log("somthing want wrong");
		}
	}
	const ongetAllMeter = async () => {
		const data7 = await getAllMeter(true);
		if (data7.success === true) {
			const options = []
			data7?.data?.data?.map((item) => (options.push({ value: item?.METER_UNIQUE_ID, label: item?.METER_PROFILE_NAME })))
			setMeterData(options);
		} else {
			console.log("somthing want wrong");
		}
	}
    const onGetTags = async () => {
		const data = await getTags()
		if (data.success === true) {
			settagsList(data.data.data.map((item) => ({ value: item?.UNIQUE_ID, label: item.TAG_NAME })))
		} else {
			console.log('something want wrong');
		}
	}


	useEffect(() => {
		onHandaleAccount()

	}, [permision])

    useEffect(() => {
        getBadDataList()
		onHandaleRoles()

    }, [])

    const onOpenFilter = () => {
		setismodelFilter(true)
		ongetAllMeter()
		ongetAllModem()
		onGetTags()
	}

    useEffect(() => {
        onClearFilter()
    }, [btnText])

    const GetConsumerIncolumeName = async (isbetween, col, colname, value) => {
        setisModalVisible(true)
        setModalLoad(true)

        setModelId(`${colname}`)
        const data = btnText=='GSM'? await onGetConsumerIncolumeNameWithFilter({ isbetween: isbetween, colName: col, value: value, ROLES: userInfo?.ROLE,filter_obj:{...filterObj, CATEGORY1_view: permision?.ROLES_PERMISSIONS_CATEGORY1?.CATEGORY1_view, CATEGORY0_view: permision?.ROLES_PERMISSIONS_CATEGORY0?.CATEGORY0_view, CATEGORY2_view: permision?.ROLES_PERMISSIONS_CATEGORY2?.CATEGORY2_view, CATEGORY3_view: permision?.ROLES_PERMISSIONS_CATEGORY3?.CATEGORY3_view, CATEGORY4_view: permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY4_view, CATEGORY5_view: permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY5_view, Roles: userInfo?.ROLE} }):await onGetLoraConsumerIncolumeNameWithFilter({ isbetween: isbetween, colName: col, value: value, ROLES: userInfo?.ROLE,filter_obj:{...filterObj, CATEGORY1_view: permision?.ROLES_PERMISSIONS_CATEGORY1?.CATEGORY1_view, CATEGORY0_view: permision?.ROLES_PERMISSIONS_CATEGORY0?.CATEGORY0_view, CATEGORY2_view: permision?.ROLES_PERMISSIONS_CATEGORY2?.CATEGORY2_view, CATEGORY3_view: permision?.ROLES_PERMISSIONS_CATEGORY3?.CATEGORY3_view, CATEGORY4_view: permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY4_view, CATEGORY5_view: permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY5_view, Roles: userInfo?.ROLE }})
        if (data.success === true) {
            setTableData(data.data.data)
            if (data.data.data.length > 0) {
            }
            setModalLoad(false)

        } else {
            setModalLoad(false)
            console.log('somthing want wrong')
        }
    }

    const onHandalebtn = (text) => {
		setButtontext(text);
	};

    const handleChangeS = (e) => {
		if (e.target.checked) {
			if (Profile.hasOwnProperty(e.target.id)) {
				setProfile({ ...Profile, [e.target.id]: true })
				setFilterObj({ ...filterObj, [e.target.name]: [] })

			}
			if (consumer.hasOwnProperty(e.target.id)) {
				setConsumer({ ...consumer, [e.target.id]: true })
				setFilterObj({ ...filterObj, [e.target.name]: '' })

			}
			if (modem.hasOwnProperty(e.target.id)) {
				setModem({ ...modem, [e.target.id]: true })
			}
			if (e.target.id == 'checktextLS') {
				setFilterObj({ ...filterObj, [e.target.name]: {} })
			}
			if (e.target.id == 'checktextRSSI') {
				setFilterObj({ ...filterObj, [e.target.name]: {} })
			}
			if (e.target.id == 'checktextInTS') {
				setFilterObj({ ...filterObj, [e.target.name]: {} })
			}
			if (e.target.id == 'checktextBP') {
				setFilterObj({ ...filterObj, [e.target.name]: {} })
			}
			if (e.target.id == 'checktextDRTS') {
				setFilterObj({ ...filterObj, [e.target.name]: {} })
			}
		} else {
			if (Profile.hasOwnProperty(e.target.id)) {
				setProfile({ ...Profile, [e.target.id]: false })
				delete filterObj[e.target.name]
				delete showfilterObj[e.target.name]
			}
			if (consumer.hasOwnProperty(e.target.id)) {
				setConsumer({ ...consumer, [e.target.id]: false })
				delete filterObj[e.target.name]
				delete showfilterObj[e.target.name]
				if (e.target.id == 'checktextDRTS') {
					setDRState({ ...DRState, greaterThan: false, lessThan: false, Between: false })
				}
			}
			if (modem.hasOwnProperty(e.target.id)) {
				setModem({ ...modem, [e.target.id]: false })
				if (e.target.id == 'checktextRSSI') {
					delete filterObj[e.target.name]
					delete showfilterObj[e.target.name]
					setModemState({ ...modemStart, greaterThan: false, lessThan: false, Between: false })
				}
				if (e.target.id == 'checktextBP') {
					delete filterObj[e.target.name]
					delete showfilterObj[e.target.name]
					setbetteryPr({ ...betteryPr, greaterThan: false, lessThan: false, Between: false })
				}
				if (e.target.id == 'checktextLS') {
					console.log(e.target.id)
					delete filterObj[e.target.name]
					delete showfilterObj[e.target.name]
					setLastSeen({ ...last, greaterThan: false, lessThan: false })
				}
			}
		}
	}

    const handleSelectChange = (e) => {
		const stateUpdate = Object.keys(modemStart)
		setModemState(stateUpdate.reduce((obj, data) => ({ ...obj, [e.value]: true }), {}))
		setFilterObj({ ...filterObj, RSSI: stateUpdate.reduce((obj, data) => ({ ...obj, [e.value]: "True" }), {}) })
	};

	const handleSelectChangeInstall = (e) => {
		const stateUpdate = Object.keys(modemStart)
		setinstallState(stateUpdate.reduce((obj, data) => ({ ...obj, [e.value]: true }), {}))
		setFilterObj({ ...filterObj, Installation_Date: stateUpdate.reduce((obj, data) => ({ ...obj, [e.value]: "True" }), {}) })
	};
	const handleSelectChangeDR = (e) => {
		const stateUpdate = Object.keys(modemStart)
		setDRState(stateUpdate.reduce((obj, data) => ({ ...obj, [e.value]: true }), {}))
		setFilterObj({ ...filterObj, Dataretrival_Date: stateUpdate.reduce((obj, data) => ({ ...obj, [e.value]: "True" }), {}) })
	};
	const handleBetteryPr = (e) => {
		const BpUpdate = Object.keys(betteryPr)
		setbetteryPr(BpUpdate.reduce((obj, data) => ({ ...obj, [e.value]: true }), {}))
		setFilterObj({ ...filterObj, BAT_PER: BpUpdate.reduce((obj, data) => ({ ...obj, [e.value]: "True" }), {}) })

	};

	const handleLastSeen = (e) => {
		const lastSeenUpdate = Object.keys(last)
		setLastSeen(lastSeenUpdate.reduce((obj, data) => ({ ...obj, [e.value]: true }), {}))
		setFilterObj({ ...filterObj, Last_Seen: { ...filterObj.Last_Seen, [e.value]: 'True' } })

	};


	const customStyles = {
		menu: provided => ({ ...provided, zIndex: 9999 }),
		multiValue: (provided, { data }) => {
			return {
				...provided,
				width: 'min-content',
				backgroundColor: "#6777ef",
			};
		},
		multiValueLabel: (styles, { data }) => ({
			...styles,
			color: "white",
		}),


	}

	const animatedComponents = makeAnimated();

	const options1 = [
		{ value: "account-adani", label: 'Adani Total Gas Limited' },
		{ value: "meMighty", label: 'MEMIGHTY' },
	]

	const consumers = [
		{ value: 'all', label: 'All' },
		{ value: '1', label: 'Active' },
		{ value: '0', label: 'InActive' },
		{ value: '-1', label: 'Pending Configurations' },
		{ value: '2', label: 'Under Maintenance' },
		{ value: '3', label: 'Stand By' }

	]
	
	const dataWise = [
		{ value: "Between", label: 'Is between' },
		{ value: "LessEqual", label: 'Is Less than Equel to' },
		{ value: "GreaterEqual", label: "Is Greater than Equel to" }
	]
	const lastSeenWise = [
		{ value: "LessEqual", label: 'Less than' },
		{ value: "GreaterEqual", label: 'Greater than' }
	]
	const lastSeenWiseOption = [
		{ value: "Hours", label: 'Hours' },
		{ value: "Minutes", label: 'Minutes' }
	]
	const lastSeenWiseShort = [
		{ value: "desc", label: 'Desc' },
		{ value: "asc", label: 'Asc' }
	]
	const consumerTypeArray = [
		{ value: "Industrial", label: 'Industrial' },
		{ value: "Residential", label: 'Residential' },
		{ value: "Commercial", label: 'Commercial' },
		{ value: "DRS", label: 'DRS' },
	]

    const onSearchMultiFilterJson = (newSearchTerms,json_name) => {
		setFilterObj({ ...filterObj, [json_name]: newSearchTerms })
		
	};
	
	const onItemClearedFilterJson  = (clearedIndex,json_name) => {
		// Create a new array without the cleared item
		const newSearchTerms = searchTerms.filter((_, index) => index !== clearedIndex);
		// Update the search results based on the new search terms
		onSearchMultiFilterJson(newSearchTerms,json_name);
	};
	const onClearAllItemsFilterJson  = (arr,json_name) => {
		// Reset the search results to the original data
		onSearchMultiFilterJson([],json_name);
	
	};

    const onSubmiteFilter=()=>{
		setFilterLoader(true)
        getBadDataList(true)
        
    }

    const onClearFilter = async () => {
		setFilterLoader(true)
        setLoader(true)
		setFilterObj({Status:'1'})
		setShowFilterObj({Status: 'Active' })
		setProfile({
			accountuser: false,
			gauser: false,
			circleuser: false,
			areauser: false,
			divisionuser: false,
			subDivisionuser: false,
		})
		setDRState({...DRState,greaterThan: false, lessThan: false, Between: false })
		setModemState({ ...modemStart, greaterThan: false, lessThan: false, Between: false })
		setbetteryPr({ ...betteryPr, greaterThan: false, lessThan: false, Between: false })
		setLastSeen({ ...last, greaterThan: false, lessThan: false })
		setinstallState({ ...installState, greaterThan: false, lessThan: false, Between: false })
		setConsumer({
			checktext1: false,
			checktext2: false,
			checktext3: false,
			checktext4: false,
			checktext5: false,
			checktext6: false,
			checktext7: false,
			checktextCS: true,
			checktextMP: false,
			checktextMOP: false,
			checktextTA: false,
			checktextInTS: false,
			checktextLSs: false,
			Consumer_Type: false,
			checktextDRTS:false

		})
		setModem({
			checktextRSSI: false,
			checktextLS: false,
			checktextBP: false,
		})
		
        const data = await badDataAnalytics({tableName:btnText=="GSM"?"gsm_consumer_device_index":"lora_consumer_device_index",filter_obj:{Status:'1', CATEGORY1_view: permision?.ROLES_PERMISSIONS_CATEGORY1?.CATEGORY1_view, CATEGORY0_view: permision?.ROLES_PERMISSIONS_CATEGORY0?.CATEGORY0_view, CATEGORY2_view: permision?.ROLES_PERMISSIONS_CATEGORY2?.CATEGORY2_view, CATEGORY3_view: permision?.ROLES_PERMISSIONS_CATEGORY3?.CATEGORY3_view, CATEGORY4_view: permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY4_view, CATEGORY5_view: permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY5_view, Roles: userInfo?.ROLE }})
        if (data.success == true) {
            setBadData(data?.data?.data[0] || {})
        setLoader(false)

        } else {
            toast.error('Server Issue')
        setLoader(false)

        }
		setFilterLoader(false)
	}
    return (<>
        {<Suspense fallback={<><Spin size="large" /></>}>
            <BootstrapModal className="my-modal-class" show={isModalVisible} onHide={() => { setisModalVisible(false)
            setTableData([]) }} size={"xl"} >
                <BootstrapModal.Header closeButton><BootstrapModal.Title style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
                    {ModelId}
                    {/* {TableData.length > 0?<span className='btn btn-primary text-white ml-2' onClick={Download_Logs}><i className='fas fa-download'></i></span>:''}*/}
						{TableData.length > 0?<Link to={{  pathname: btnText=='GSM'?`All-GSM`:'All-Lorawan',state: { detail: TableData.map((data)=>(data?.UNIQUE_ID)),title:ModelId+` Is Null` }  }}><span className='btn btn-primary text-white ml-2'><i className='fas fa-up-right-from-square'></i></span></Link>:''} 
                </BootstrapModal.Title></BootstrapModal.Header>
                <BootstrapModal.Body style={{ maxHeight: '90vh', overflow: 'auto', paddingTop: '0px' }}>
                    <div className="modal-table">
                        {ModalLoad ? (
                            <div className="example">
                                <Spin size="large" />
                            </div>
                        ) : <table className="table border table-borderless" id="table-1">
                            <thead style={{ position: 'sticky', top: '0', background: '#fff' }}>
                                <tr>
                                    <th className="text-center">SR NO.</th>
                                    <th className="text-center">Consumer Name</th>
                                    <th className="text-center">Modem Serial No</th>
                                </tr>
                            </thead>
                            <tbody id="tbody">
                                <>
                                    {TableData.length > 0 ?
                                        TableData.map((data, id) => (
                                            <tr style={{ height: "4rem", cursor: 'pointer' }} className="trheigth even:tw-bg-gray-100 hover:tw-bg-[#D8D8D8]" key={id} >
                                                <td className="text-center">{id + 1}</td>
                                                <td className="text-center">{data?.address_compony_name}</td>
                                                <td className="text-center">{data?.DEVICE_SERIAL_NO}</td>
                                            </tr>
                                        )) : <tr></tr>}
                                </>
                            </tbody>
                        </table>}
                        {TableData.length === 0 && !ModalLoad && <h4 className="text-center">No Data Found</h4>}
                    </div>
                </BootstrapModal.Body>
            </BootstrapModal>
        </Suspense>
        }

<Modal title={`${btnText} Consumers Filter`} visible={ismodelFilter} footer='' onCancel={() => setismodelFilter(false)} width={1500}>

<fieldset className="customLegend">
    <legend >Group Wise Filter</legend>
    <div className="row" style={{
        marginLeft: 10,
        marginRight: 10

    }} >
        <div className="col-12">
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="accountuser" name="CATEGORY0" className="custom-control-input " value="account" checked={Profile.accountuser} onChange={handleChangeS} />
                    <label className="custom-control-label" for="accountuser">CATEGORY0</label>
                </div>
                {Profile.accountuser && (<div className="form-group col-md-3 accountgrp" style={{ marginTop: -10 }} >
                    <Select value={AccounData.filter((item) => filterObj?.CATEGORY0?.includes(item.value)) || []} placeholder='Select account...' styles={customStyles} components={animatedComponents} name='account' isMulti options={AccounData} onChange={(e) => {
                        setFilterObj({ ...filterObj, CATEGORY0: e.map((item) => (item.value)) })
                        setShowFilterObj({ ...showfilterObj, CATEGORY0: e.map((item) => (item.label)) })
                    }} />
                </div>)}
            </div>

            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="gauser" name="CATEGORY1" className="custom-control-input" value="ga" checked={Profile.gauser} onChange={handleChangeS} />
                    <label className="custom-control-label" for="gauser">CATEGORY1</label>
                </div>
                {Profile.gauser && (<div className="form-group col-md-3 gagrp" style={{ marginTop: -10 }}>
                    <Select value={GaData.filter((item) => filterObj?.CATEGORY1?.includes(item.value)) || null} styles={customStyles} components={animatedComponents} name='account' isMulti options={GaData} onChange={(e) => {
                        setFilterObj({ ...filterObj, CATEGORY1: e.map((item) => (item.value)) })
                        setShowFilterObj({ ...showfilterObj, CATEGORY1: e.map((item) => (item.label)) })
                    }} />
                </div>)}
            </div>

            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="circleuser" name="CATEGORY2" className="custom-control-input" checked={Profile.circleuser} value="circle" onChange={handleChangeS} />
                    <label className="custom-control-label" for="circleuser">CATEGORY2</label>
                </div>
                {Profile.circleuser && (<div className="form-group col-md-3 circlegrp" style={{ marginTop: -10 }}>
                    <Select value={CircleData.filter((item) => filterObj?.CATEGORY2?.includes(item.value)) || null} styles={customStyles} components={animatedComponents} name='account' isMulti options={CircleData} onChange={(e) => {
                        setFilterObj({ ...filterObj, CATEGORY2: e.map((item) => (item.value)) })
                        setShowFilterObj({ ...showfilterObj, CATEGORY2: e.map((item) => (item.label)) })
                    }} />
                </div>)}
            </div>

            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="divisionuser" name="CATEGORY3" className="custom-control-input" checked={Profile.divisionuser} value="division" onChange={handleChangeS} />
                    <label className="custom-control-label" for="divisionuser">CATEGORY3</label>
                </div>
                {Profile.divisionuser && (<div className="form-group col-md-3 divisiongrp" style={{ marginTop: -10 }}>
                    <Select value={DivisionData.filter((item) => filterObj?.CATEGORY3?.includes(item.value)) || null} styles={customStyles} components={animatedComponents} name='account' isMulti options={DivisionData} onChange={(e) => {
                        setFilterObj({ ...filterObj, CATEGORY3: e.map((item) => (item.value)) })
                        setShowFilterObj({ ...showfilterObj, CATEGORY3: e.map((item) => (item.label)) })
                    }} />

                </div>)}
            </div>

            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="subDivisionuser" name="CATEGORY4" className="custom-control-input" checked={Profile.subDivisionuser} value="subdivision" onChange={handleChangeS} />
                    <label className="custom-control-label " for="subDivisionuser">CATEGORY4</label>
                </div>
                {Profile.subDivisionuser && (<div className="form-group col-md-3 subdivisiongrp" style={{ marginTop: -10 }}>
                    <Select value={SubdevisionData.filter((item) => filterObj?.CATEGORY4?.includes(item.value)) || null} styles={customStyles} components={animatedComponents} name='account' isMulti options={SubdevisionData} onChange={(e) => {
                        setFilterObj({ ...filterObj, CATEGORY4: e.map((item) => (item.value)) })
                        setShowFilterObj({ ...showfilterObj, CATEGORY4: e.map((item) => (item.label)) })
                    }} />

                </div>)}
            </div>

            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="areauser" name="CATEGORY5" className="custom-control-input" checked={Profile.areauser} value="area" onChange={handleChangeS} />
                    <label className="custom-control-label" for="areauser">CATEGORY5</label>
                </div>
                {Profile.areauser && (<div className="form-group col-md-3 areagrp" style={{ marginTop: -10 }}>
                    <Select value={AreaData.filter((item) => filterObj?.CATEGORY5?.includes(item.value)) || null} styles={customStyles} components={animatedComponents} name='account' isMulti options={AreaData} onChange={(e) => {
                        setFilterObj({ ...filterObj, CATEGORY5: e.map((item) => (item.value)) })
                        setShowFilterObj({ ...showfilterObj, CATEGORY5: e.map((item) => (item.label)) })
                    }} />

                </div>)}
            </div>
        </div>

    </div>
</fieldset>
<fieldset className="customLegend ">
    <legend >Consumer Info Wise Filter</legend>
    <div className="row" style={{ marginLeft: 10 }}>
        <div className="col-12">
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktext1" name="Installation_Number" className="custom-control-input" checked={consumer.checktext1} value="installnumber" onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktext1">Installation Number</label>
                </div>
                {consumer.checktext1 &&<MultiInput
                    placeholder="search and enter..."
                    onChange={(arr)=>onSearchMultiFilterJson(arr,"Installation_Number")}
                    maxItems={null} // Allow any number of items
                    onClear={(arr)=>onItemClearedFilterJson(arr,"Installation_Number")}
                    onClearAll={(arr)=>onClearAllItemsFilterJson(arr,"Installation_Number")}
                />}
                
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktext2" name="Business_Number" className="custom-control-input" value="businessnu" checked={consumer.checktext2} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktext2">Business Partner Number</label>
                </div>
                {consumer.checktext2 &&<MultiInput
                    placeholder="search and enter..."
                    onChange={(arr)=>onSearchMultiFilterJson(arr,"Business_Number")}
                    maxItems={null} // Allow any number of items
                    onClear={(arr)=>onItemClearedFilterJson(arr,"Business_Number")}
                    onClearAll={(arr)=>onClearAllItemsFilterJson(arr,"Business_Number")}
                />}
                
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktext3" name="Modem_Serial_No" className="custom-control-input" value="modemserial" checked={consumer.checktext3} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktext3">Modem Serial No</label>
                </div>
                {consumer.checktext3 &&<MultiInput
                    placeholder="search and enter..."
                    onChange={(arr)=>onSearchMultiFilterJson(arr,"Modem_Serial_No")}
                    maxItems={null} // Allow any number of items
                    onClear={(arr)=>onItemClearedFilterJson(arr,"Modem_Serial_No")}
                    onClearAll={(arr)=>onClearAllItemsFilterJson(arr,"Modem_Serial_No")}
                />}
                
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktext4" name="Panel_Serial_No" className="custom-control-input" value="panelserno" checked={consumer.checktext4} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktext4">Panel Serial No</label>
                </div>
                {consumer.checktext4 &&<MultiInput
                    placeholder="search and enter..."
                    onChange={(arr)=>onSearchMultiFilterJson(arr,"Panel_Serial_No")}
                    maxItems={null} // Allow any number of items
                    onClear={(arr)=>onItemClearedFilterJson(arr,"Panel_Serial_No")}
                    onClearAll={(arr)=>onClearAllItemsFilterJson(arr,"Panel_Serial_No")}
                />}
                
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktext5" name="Unique_ID" className="custom-control-input" value="cnuniqueid" checked={consumer.checktext5} onChange={handleChangeS}/>
                    <label className="custom-control-label" for="checktext5">Consumer Unique Id</label>
                </div>
                {consumer.checktext5 &&<MultiInput
                    placeholder="search and enter..."
                    onChange={(arr)=>onSearchMultiFilterJson(arr,"Unique_ID")}
                    maxItems={null} // Allow any number of items
                    onClear={(arr)=>onItemClearedFilterJson(arr,"Unique_ID")}
                    onClearAll={(arr)=>onClearAllItemsFilterJson(arr,"Unique_ID")}
                    value={filterObj?.Unique_ID}
                />}
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktext6" name="Distirbuter_ID" className="custom-control-input" value="distid" checked={consumer.checktext6} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktext6">Customer Id</label>
                </div>
                {consumer.checktext6 &&<MultiInput
                    placeholder="search and enter..."
                    onChange={(arr)=>onSearchMultiFilterJson(arr,"Distirbuter_ID")}
                    maxItems={null} // Allow any number of items
                    onClear={(arr)=>onItemClearedFilterJson(arr,"Distirbuter_ID")}
                    onClearAll={(arr)=>onClearAllItemsFilterJson(arr,"Distirbuter_ID")}
                />}
                
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktext7" name="IMEI" className="custom-control-input" value="allimei" checked={consumer.checktext7} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktext7">imei</label>
                </div>
                {consumer.checktext7 &&<MultiInput
                    placeholder="search and enter..."
                    onChange={(arr)=>onSearchMultiFilterJson(arr,"IMEI")}
                    maxItems={null} // Allow any number of items
                    onClear={(arr)=>onItemClearedFilterJson(arr,"IMEI")}
                    onClearAll={(arr)=>onClearAllItemsFilterJson(arr,"IMEI")}
                />}
                
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktextCS" name="Status" className="custom-control-input" value="filterstatus" checked={consumer.checktextCS} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktextCS">Consumer Status</label>
                </div>
                {consumer.checktextCS && (<div className="form-group col-md-3 checktextCS filterstatus" style={{ marginTop: -10 }}>
                    <Select styles={customStyles} components={animatedComponents} name='Status' options={consumers} onChange={(e) => {
                        if(!e&&e?.value!=1&&e?.value!=0){
                            delete filterObj["SubStatus"]
                        }
                        setFilterObj({ ...filterObj, Status: e?.value||'' })
                        setShowFilterObj({ ...showfilterObj, Status: e?.label||'' })
                    }} value={[filterObj?.Status?consumers.filter((item)=>(item?.value==filterObj?.Status))[0]:[]]} isClearable />

                </div>)}
                {consumer.checktextCS&&filterObj?.Status && filterObj?.Status==1 && <div className="form-group col-md-3 checktextCS filterstatus" style={{ marginTop: -10 }}>
                    <Select styles={customStyles} components={animatedComponents} name='Status' options={[{ value: '1', label: 'Live' },{ value: '2', label: 'Temporary Disconnection' }]} onChange={(e) => {
                        setFilterObj({ ...filterObj, SubStatus: e?.value||'' })
                        setShowFilterObj({ ...showfilterObj, SubStatus: e?.label||'' })
                    }} isClearable/>
                </div>}
                {consumer.checktextCS &&filterObj?.Status && filterObj?.Status==0 && <div className="form-group col-md-3 checktextCS filterstatus" style={{ marginTop: -10 }}>
                    <Select styles={customStyles} components={animatedComponents} name='Status' options={[{ value: '3', label: 'Permanent Disconnection' }]} onChange={(e) => {
                        setFilterObj({ ...filterObj, SubStatus: e?.value||'' })
                        setShowFilterObj({ ...showfilterObj, SubStatus: e?.label||'' })
                    }} isClearable/>
                </div>}
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktextMP" name="Meter_Profile" className="custom-control-input" value="meterprofile" checked={consumer.checktextMP} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktextMP">EVC Profile</label>
                </div>
                {consumer.checktextMP && (<div className="form-group col-md-3 checktextMP meterprofile" style={{ marginTop: -10 }}>
                    <Select styles={customStyles} components={animatedComponents} name='Meter_Profile' options={MeterData} isMulti onChange={(e) => {
                        setFilterObj({ ...filterObj, Meter_Profile: e.map((item) => (item.value)) })
                        setShowFilterObj({ ...showfilterObj, Meter_Profile: e.map((item) => (item.label)) })
                    }} />

                </div>)}
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktextMOP" name="Modem_Profile" className="custom-control-input" value="modemprofile" checked={consumer.checktextMOP} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktextMOP">Modem Profile</label>
                </div>
                {consumer.checktextMOP && (<div className="form-group col-md-3 checktextMOP modemprofile" style={{ marginTop: -10 }}>
                    <Select styles={customStyles} components={animatedComponents} name='Modem_Profile' options={ModemData} isMulti onChange={(e) => {
                        setFilterObj({ ...filterObj, Modem_Profile: e.map((item) => (item.value)) })
                        setShowFilterObj({ ...showfilterObj, Modem_Profile: e.map((item) => (item.label)) })
                    }} />

                </div>)}
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktextTA" name="Tags" className="custom-control-input" value="tagsvalue" checked={consumer.checktextTA} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktextTA">Tags</label>
                </div>
                {consumer.checktextTA && (<div className="form-group col-md-3 checktextTA tagsvalue" style={{ marginTop: -10 }}>
                    <Select styles={customStyles} name='Tags' isMulti options={tagsList} onChange={(e) => {
                        setFilterObj({ ...filterObj, Tags: e.map((item) => (item.value)) })
                        setShowFilterObj({ ...showfilterObj, Tags: e.map((item) => (item.label)) })
                    }
                    } />

                </div>)}

            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktextInTS" name="Installation_Date" className="custom-control-input" value="tagsvalue" checked={consumer.checktextInTS} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktextInTS">Installation Date</label>
                </div>
                {consumer.checktextInTS && (<div className="form-group col-md-3 checktextRSSI length rssival" style={{ marginTop: -10 }}>
                    <Select components={animatedComponents} placeholder="Select Condition..." name='RSSI' options={dataWise}
                        styles={customStyles} onChange={handleSelectChangeInstall} />

                </div>)}
                {consumer.checktextInTS&& installState?.Between && (<div className="form-group col-md-4 checktextTA tagsvalue" style={{ marginTop: -10 }}>
                    <Space direction="horizontal">
                        <div className="d-flex flex-column">Start In</div>
                        <DatePicker onChange={(e, dateString) => setFilterObj({ ...filterObj, Installation_Date: { ...filterObj.Installation_Date, Start_Date: dateString } })} format='DD-MM-YYYY' name='start'
                            disabledDate={(current) => {
                                return current.isAfter(moment())
                            }} />
                        <div className="d-flex flex-column" >End In</div>
                        <DatePicker onChange={(e, dateString) => setFilterObj({ ...filterObj, Installation_Date: { ...filterObj.Installation_Date, End_Date: dateString } })} name='end' format='DD-MM-YYYY' disabledDate={(current) => {
                            return current.isAfter(moment())
                        }} />
                    </Space>

                </div>)}
                {consumer.checktextInTS&& installState?.LessEqual && (<div className="form-group col-md-4 checktextTA tagsvalue" style={{ marginTop: -10 }}>
                    <Space direction="horizontal">
                        <div className="d-flex flex-column">Date</div>
                        <DatePicker onChange={(e, dateString) => setFilterObj({ ...filterObj, Installation_Date: { ...filterObj.Installation_Date, Start_Date: dateString } })} format='DD-MM-YYYY' name='start'
                            disabledDate={(current) => {
                                return current.isAfter(moment())
                            }} />
                    </Space>

                </div>)}
                {consumer.checktextInTS&& installState?.GreaterEqual && (<div className="form-group col-md-4 checktextTA tagsvalue" style={{ marginTop: -10 }}>
                    <Space direction="horizontal">
                        <div className="d-flex flex-column">Date</div>
                        <DatePicker onChange={(e, dateString) => setFilterObj({ ...filterObj, Installation_Date: { ...filterObj.Installation_Date, Start_Date: dateString } })} format='DD-MM-YYYY' name='start'
                            disabledDate={(current) => {
                                return current.isAfter(moment())
                            }} />
                    </Space>

                </div>)}
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktextDRTS" name="Dataretrival_Date" className="custom-control-input" value="tagsvalue" checked={consumer.checktextDRTS} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktextDRTS">Data Retrival Date</label>
                </div>
                {consumer.checktextDRTS && (<div className="form-group col-md-3 checktextRSSI length rssival" style={{ marginTop: -10 }}>
                    <Select components={animatedComponents} placeholder="Select Condition..." name='RSSI' options={dataWise}
                        styles={customStyles} onChange={handleSelectChangeDR} />

                </div>)}
                {consumer.checktextDRTS&& DRState?.Between && (<div className="form-group col-md-4 checktextTA tagsvalue" style={{ marginTop: -10 }}>
                    <Space direction="horizontal">
                        <div className="d-flex flex-column">Start In</div>
                        <DatePicker onChange={(e, dateString) => setFilterObj({ ...filterObj, Dataretrival_Date: { ...filterObj.Dataretrival_Date, Start_Date: dateString } })} format='DD-MM-YYYY' name='start'
                            disabledDate={(current) => {
                                return current.isAfter(moment())
                            }} />
                        <div className="d-flex flex-column" >End In</div>
                        <DatePicker onChange={(e, dateString) => setFilterObj({ ...filterObj, Dataretrival_Date: { ...filterObj.Dataretrival_Date, End_Date: dateString } })} name='end' format='DD-MM-YYYY' disabledDate={(current) => {
                            return current.isAfter(moment())
                        }} />
                    </Space>

                </div>)}
                {consumer.checktextDRTS&& DRState?.LessEqual && (<div className="form-group col-md-4 checktextTA tagsvalue" style={{ marginTop: -10 }}>
                    <Space direction="horizontal">
                        <div className="d-flex flex-column">Date</div>
                        <DatePicker onChange={(e, dateString) => setFilterObj({ ...filterObj, Dataretrival_Date: { ...filterObj.Dataretrival_Date, Start_Date: dateString } })} format='DD-MM-YYYY' name='start'
                            disabledDate={(current) => {
                                return current.isAfter(moment())
                            }} />
                    </Space>

                </div>)}
                {consumer.checktextDRTS&& DRState?.GreaterEqual && (<div className="form-group col-md-4 checktextTA tagsvalue" style={{ marginTop: -10 }}>
                    <Space direction="horizontal">
                        <div className="d-flex flex-column">Date</div>
                        <DatePicker onChange={(e, dateString) => setFilterObj({ ...filterObj, Dataretrival_Date: { ...filterObj.Dataretrival_Date, Start_Date: dateString } })} format='DD-MM-YYYY' name='start'
                            disabledDate={(current) => {
                                return current.isAfter(moment())
                            }} />
                    </Space>

                </div>)}
            </div>
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="Consumer_Type" name="Consumer_Type" className="custom-control-input" value="area" checked={consumer.Consumer_Type} onChange={handleChangeS} />
                    <label className="custom-control-label" for="Consumer_Type">Consumer Type</label>
                </div>
                {consumer?.Consumer_Type && <div class="form-group col-md-3">
                    <Select styles={customStyles} components={animatedComponents} name='Consumer_Type' isMulti options={consumerTypeArray} onChange={(e) => {
                        setFilterObj({ ...filterObj, Consumer_Type: e.map((item) => (item.value)) })
                        setShowFilterObj({ ...showfilterObj, Consumer_Type: e.map((item) => (item.label)) })
                    }} />
                    {/* <select
                                            class="form-control form-select modemtypename anothermodemname"
                                            name="cust_sal"
                                            id="filter_course"
                                            required=""
                                            onChange={(e) => (setFilterObj({ ...filterObj, Consumertype: e.target.value }))}
                                            value={filterObj.Consumertype}
                                        >
                                            <option value="">Select Consumer Type </option>
                                            <option value="Residential">Residential</option>
                                            <option value="Industrial">Industrial</option>
                                            <option value="Commercial">Commercial</option>
                                        </select> */}
                </div>}
            </div>
        </div>
    </div>
</fieldset>

<fieldset className="customLegend ">
    <legend >Modem Data Wise Filter</legend>
    <div className="row" style={{ marginLeft: 10 }}>
        <div className="col-12">
            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktextRSSI" name="RSSI" className="custom-control-input" value="rssival" checked={modem.checktextRSSI} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktextRSSI">RSSI</label>
                </div>
                {modem.checktextRSSI && (<div className="form-group col-md-3 checktextRSSI length rssival" style={{ marginTop: -10 }}>
                    <Select components={animatedComponents} placeholder="Select Condition..." name='RSSI' options={dataWise}
                        styles={customStyles} onChange={handleSelectChange} />

                </div>)}
                {modemStart.Between && modem.checktextRSSI && (<div className="form-group col-md-3 checktext14" style={{ marginTop: -10 }}>
                    <input type="text" className="form-control" name="filter_rssi_from" id="filter_rssi_from" placeholder="From" onChange={(e) => { setFilterObj({ ...filterObj, RSSI: { ...filterObj.RSSI, From: e.target.value } }) }} />
                </div>)}
                {modemStart.Between && modem.checktextRSSI && (<div className="form-group col-md-3 checktext13" style={{ marginTop: -10 }}>
                    <input type="text" className="form-control" name="filter_rssi_to" id="filter_rssi_to" placeholder="To" onChange={(e) => { setFilterObj({ ...filterObj, RSSI: { ...filterObj.RSSI, To: e.target.value } }) }} />
                </div>)}
                {modemStart.LessEqual && modem.checktextRSSI && (<div className="form-group col-md-3 checktext13" style={{ marginTop: -10 }}>
                    <input type="text" className="form-control" name="filter_rssi_less_then" id="filter_rssi_less_then" placeholder="less than..." onChange={(e) => { setFilterObj({ ...filterObj, RSSI: { ...filterObj.RSSI, Value: e.target.value } }) }} />
                </div>)}
                {modemStart.GreaterEqual && modem.checktextRSSI && (<div className="form-group col-md-3 checktext13" style={{ marginTop: -10 }}>
                    <input type="text" className="form-control" name="filter_rssi_greater_then" id="filter_rssi_greater_then" placeholder="greter than..." onChange={(e) => { setFilterObj({ ...filterObj, RSSI: { ...filterObj.RSSI, Value: e.target.value } }) }} />
                </div>)}
            </div>

            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktextBP" name="BAT_PER" className="custom-control-input" value="BAT_PER" checked={modem.checktextBP} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktextBP">Battery Percentage</label>
                </div>
                {modem.checktextBP && (<div className="form-group col-md-3 checktextBP length batperval" style={{ marginTop: -10 }}>
                    <Select components={animatedComponents} styles={customStyles} name='account' options={dataWise}
                        onChange={handleBetteryPr} placeholder="Select Condition..." />

                </div>)}

                {betteryPr.Between && modem.checktextBP && (<div className="form-group col-md-3 checktext14" style={{ marginTop: -10 }}>
                    <input type="text" className="form-control" name="filter_rssi_from" id="filter_rssi_from" placeholder="From" onChange={(e) => { setFilterObj({ ...filterObj, BAT_PER: { ...filterObj.BAT_PER, From: e.target.value } }) }} />
                </div>)}
                {betteryPr.Between && modem.checktextBP && (<div className="form-group col-md-3 checktext13" style={{ marginTop: -10 }}>
                    <input type="text" className="form-control" name="filter_rssi_to" id="filter_rssi_to" placeholder="To" onChange={(e) => { setFilterObj({ ...filterObj, BAT_PER: { ...filterObj.BAT_PER, To: e.target.value } }) }} />
                </div>)}
                {betteryPr.LessEqual && modem.checktextBP && (<div className="form-group col-md-3 checktext13" style={{ marginTop: -10 }}>
                    <input type="text" className="form-control" name="filter_rssi_less_then" id="filter_rssi_less_then" placeholder="less than..." onChange={(e) => { setFilterObj({ ...filterObj, BAT_PER: { ...filterObj.BAT_PER, Value: e.target.value } }) }} />
                </div>)}
                {betteryPr.GreaterEqual && modem.checktextBP && (<div className="form-group col-md-3 checktext13" style={{ marginTop: -10 }}>
                    <input type="text" className="form-control" name="filter_rssi_greater_then" id="filter_rssi_greater_then" placeholder="greter than..." onChange={(e) => { setFilterObj({ ...filterObj, BAT_PER: { ...filterObj.BAT_PER, Value: e.target.value } }) }} />
                </div>)}
            </div>

            <div className="form-row">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" id="checktextLS" name="Last_Seen" className="custom-control-input" value="lastssen" checked={modem.checktextLS} onChange={handleChangeS} />
                    <label className="custom-control-label" for="checktextLS">Last seen</label>
                </div>
                {modem.checktextLS && (<div className="form-group col-md-3 checktextLS lastssen" style={{ marginTop: -10 }}>
                    <Select components={animatedComponents} styles={customStyles} name='Last_Seen' options={lastSeenWiseOption} placeholder="Select Condition..."
                        onChange={(e) => { setFilterObj({ ...filterObj, Last_Seen: { ...filterObj.Last_Seen, Last_Seen: e.value } }) }} />
                </div>)}
                {modem.checktextLS && (<div className="form-group col-md-3 checktextLS lastssen" style={{ marginTop: -10 }}>
                    <Select components={animatedComponents} styles={customStyles} name='Last_Seen' options={lastSeenWise} placeholder="Select Condition..."
                        onChange={handleLastSeen} />
                </div>)}

                {last.LessEqual && modem.checktextLS && (<div className="form-group col-md-3 checktext31" style={{ marginTop: -10 }}>
                    <input type="text" className="form-control" name="filter_hours" id="filter_less_hours" placeholder="" onChange={(e) => { setFilterObj({ ...filterObj, Last_Seen: { ...filterObj.Last_Seen, Value: e.target.value } }) }} />
                </div>)}

                {last.GreaterEqual && modem.checktextLS && (<div className="form-group col-md-3 checktext31" style={{ marginTop: -10 }}>
                    <input type="text" className="form-control" name="filter_hours" id="filter_greater_hours" placeholder="" onChange={(e) => { setFilterObj({ ...filterObj, Last_Seen: { ...filterObj.Last_Seen, Value: e.target.value } }) }} />
                </div>)}
            </div>



        </div>
    </div>
</fieldset>
<div className="text-left mt-2">
    <input type="submit" className={`btn btn-danger mr-2 ${FilterLoader == true ? 'btn-progress disabled' : ''}`} value="Filter" name="filter_customer_form" onClick={onSubmiteFilter} />
    <Link className="btn btn-light text-dark" to="/BadDataAnalytics">Reset</Link>
</div>
</Modal>
        {Loader ? (
            <div className="loader"></div>
        ) : (
            ""
        )}
        {/* <div className="main-content" style={{ minHeight: "562px" }}> */}
            <section className="section">
                <div class="section-body">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-lg-12 tw-p-0">
                            <div class="card">
                                {/* <div class="card-header" > */}
                                    {/* <h3 className='mb-0'>Bad Data Analytics</h3> */}
                                {/* </div> */}
                                <div className="d-flex justify-content-between ml-4 mt-2 mb-4">
					<div className="buttons">
						{buttonArray.map((item, id) => (
							<button
							style={{
								backgroundColor: buttonArray.findIndex((data) => data === btnText) === id ? chroma(btnColor[id]).alpha(0.4).css() : '',
								color: buttonArray.findIndex((data) => data === btnText) === id ? chroma(btnColor[id]).darken(1.5).css() : btnColor[id],
								borderBottom: `1px solid ${btnColor[id]}`,
								boxShadow: buttonArray.findIndex((data) => data === btnText) === id ? `0 2px 8px -3px ${btnColor[id]}`  : '',
							}}
							className={`tw-font-semibold tw-transition-all tw-bg-transparent tw-border-t-0 tw-border-r-0 tw-border-l-0 ml-2 tw-px-2 tw-mx-1 tw-my-1 tw-py-1 md:tw-px-3 md:tw-m-0 md:tw-py-2 focus:tw-outline-none ${buttonArray.findIndex((data) => data === btnText) === id ? 'tw-rounded' : 'hover:tw-bg-gray-100 hover:tw-rounded'}`}
							onClick={() => onHandalebtn(item)}>
							{item}
						</button>
						))}
                        <div>
                        
                        </div>

					</div>
                    <button type="button" className="btn btn-info mr-2" onClick={() => (onOpenFilter())}>
												<BootstrapTooltip title="Filter">
													<span>
														<i className="fa fa-filter text-white"></i>
													</span>
												</BootstrapTooltip>
											</button>
                    </div>
                    <FilterDisplay filter={{ ...filterObj, ...showfilterObj }} onClearFilter={onClearFilter}/>
                               
                                <div className="table-responsive">
                                    <div id="table-1_wrapper" class="dataTables_wrapper no-footer">
                                        <div class="dataTables_length" id="table_id_length">

                                        </div>
                                        <table id="table_id" className="table table-bordered text-center   font-13">
                                            <thead>
                                                <tr>
                                                    <th>SRNO</th>
                                                    <th>Components</th>
                                                    <th>Fields</th>
                                                    <th>Null Count</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {btnText=='GSM'?Object.entries(objectComponet).map(([key,value],id)=>(
                                                    <>
                                                    <tr className="" >
                                                        <td rowSpan={`${value?.length}`}>{id+1}.</td>
                                                        <td rowSpan={`${value?.length}`}>{key}</td>
                                                        <td>{value[0]?.lable}</td>
                                                        <td><button class="tw-font-medium tw-text-white tw-px-2 tw-rounded hover:tw-bg-indigo-100 tw-border tw-border-transparent hover:tw-border-gray-300 tw-transition-all" style={{ backgroundColor: 'rgb(58, 186, 244)' }} onClick={()=>{key=='Address'?GetConsumerIncolumeName(false,'',value[0]?.lable, `JSON_VALUE(ADDRESS,'$.${value[0]?.key}')='' OR JSON_VALUE(ADDRESS,'$.${value[0]?.key}') IS NULL`):key=='Installation Details'?GetConsumerIncolumeName(false,'',value[0]?.lable, value[0]?.key=='INSTALLATION_ATTECHMENTS'?`${value[0]?.key}='' OR ${value[0]?.key} IS NULL OR ${value[0]?.key}='[]'`:`JSON_VALUE(INSTALLATION_DETAILS,'$.${value[0]?.key}')='' OR JSON_VALUE(INSTALLATION_DETAILS,'$.${value[0]?.key}') IS NULL`):key=='Contact Person'?GetConsumerIncolumeName('JSON','',value[0]?.lable, `CP.${value[0]?.key}='' OR CP.${value[0]?.key} IS NULL`):GetConsumerIncolumeName(false,'',value[0]?.lable, `${value[0]?.key}=''  OR ${value[0]?.key} IS NULL`)}}>{BadData[value[0]?.key] || 0}</button></td>
                                                    </tr>
                                                    {value.map((item,ids)=>(ids !== 0 && <tr>
                                                    <td>{item?.lable}</td>
                                                    <td><button class="tw-font-medium tw-text-white tw-px-2 tw-rounded hover:tw-bg-indigo-100 tw-border tw-border-transparent hover:tw-border-gray-300 tw-transition-all" style={{ backgroundColor: 'rgb(58, 186, 244)' }} onClick={()=>{key=='Address'?GetConsumerIncolumeName(false,'',item?.lable, `JSON_VALUE(ADDRESS,'$.${item?.key}')='' OR JSON_VALUE(ADDRESS,'$.${item?.key}') IS NULL`):key=='Installation Details'?GetConsumerIncolumeName(false,'',item?.lable, item?.key=='INSTALLATION_ATTECHMENTS'?`${item?.key}='' OR ${item?.key} IS NULL OR ${item?.key}='[]'`:`JSON_VALUE(INSTALLATION_DETAILS,'$.${item?.key}')='' OR JSON_VALUE(INSTALLATION_DETAILS,'$.${item?.key}') IS NULL`):key=='Contact Person'?GetConsumerIncolumeName('JSON','',item?.lable, `CP.${item?.key}='' OR CP.${item?.key} IS NULL`):GetConsumerIncolumeName(false,'',item?.lable, `${item?.key}=''  OR ${item?.key} IS NULL`)}}>{BadData[item?.key] || 0}</button></td>
                                                </tr>))}
                                                    </>

                                                )):Object.entries(objectLoraComponet).map(([key,value],id)=>(
                                                    <>
                                                    <tr className="" >
                                                        <td rowSpan={`${value?.length}`}>{id+1}.</td>
                                                        <td rowSpan={`${value?.length}`}>{key}</td>
                                                        <td>{value[0]?.lable}</td>
                                                        <td><button class="tw-font-medium tw-text-white tw-px-2 tw-rounded hover:tw-bg-indigo-100 tw-border tw-border-transparent hover:tw-border-gray-300 tw-transition-all" style={{ backgroundColor: 'rgb(58, 186, 244)' }} onClick={()=>{key=='Address'?GetConsumerIncolumeName(false,'',value[0]?.lable, `JSON_VALUE(ADDRESS,'$.${value[0]?.key}')='' OR JSON_VALUE(ADDRESS,'$.${value[0]?.key}') IS NULL`):key=='Installation Details'?GetConsumerIncolumeName(false,'',value[0]?.lable, value[0]?.key=='INSTALLATION_ATTECHMENTS'?`${value[0]?.key}='' OR ${value[0]?.key} IS NULL OR ${value[0]?.key}='[]'`:`JSON_VALUE(INSTALLATION_DETAILS,'$.${value[0]?.key}')='' OR JSON_VALUE(INSTALLATION_DETAILS,'$.${value[0]?.key}') IS NULL`):key=='Contact Person'?GetConsumerIncolumeName('JSON','',value[0]?.lable, `CP.${value[0]?.key}='' OR CP.${value[0]?.key} IS NULL`):GetConsumerIncolumeName(false,'',value[0]?.lable, `${value[0]?.key}=''  OR ${value[0]?.key} IS NULL`)}}>{BadData[value[0]?.key] || 0}</button></td>
                                                    </tr>
                                                    {value.map((item,ids)=>(ids !== 0 && <tr>
                                                    <td>{item?.lable}</td>
                                                    <td><button class="tw-font-medium tw-text-white tw-px-2 tw-rounded hover:tw-bg-indigo-100 tw-border tw-border-transparent hover:tw-border-gray-300 tw-transition-all" style={{ backgroundColor: 'rgb(58, 186, 244)' }} onClick={()=>{key=='Address'?GetConsumerIncolumeName(false,'',item?.lable, `JSON_VALUE(ADDRESS,'$.${item?.key}')='' OR JSON_VALUE(ADDRESS,'$.${item?.key}') IS NULL`):key=='Installation Details'?GetConsumerIncolumeName(false,'',item?.lable, item?.key=='INSTALLATION_ATTECHMENTS'?`${item?.key}='' OR ${item?.key} IS NULL OR ${item?.key}='[]'`:`JSON_VALUE(INSTALLATION_DETAILS,'$.${item?.key}')='' OR JSON_VALUE(INSTALLATION_DETAILS,'$.${item?.key}') IS NULL`):key=='Contact Person'?GetConsumerIncolumeName('JSON','',item?.lable, `CP.${item?.key}='' OR CP.${item?.key} IS NULL`):GetConsumerIncolumeName(false,'',item?.lable, `${item?.key}=''  OR ${item?.key} IS NULL`)}}>{BadData[item?.key] || 0}</button></td>
                                                </tr>))}
                                                    </>

                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        {/* </div> */}
    </>
    )
}
